import axios from 'axios';
import React from 'react';
import { Alert, Col, Row, Space, Typography } from 'antd';
import PanelLog from './stats/PanelLog';
import PanelRecord from './stats/PanelRecord';
import PanelTest from './stats/PanelTest';
import { StatsApi } from '../../services/Api';

interface StatsContentProps {
    trans: (key: string) => string;
    handleError?: (title: string, info: string) => void;
    handleConfirm?: (title: string, info: string, op: () => void) => void;
    fileList?: unknown[];
    appList?: unknown[];
}

interface StatsContentState {
    loading: boolean;
    error?: string;
}

export default class StatsContent extends React.Component<StatsContentProps, StatsContentState> {
    private childRecord = React.createRef<PanelRecord>();
    private childLog = React.createRef<PanelLog>();
    private childTest = React.createRef<PanelTest>();

    state: StatsContentState = { loading: false };

    componentDidMount() {
        this.getStatistics();
    }

    getStatistics = () => {
        const lang = localStorage.getItem('lang') || 'zh_CN';
        const requestData = { lang: lang.split('_')[0] };
        this.fetchRecordInfo(requestData);
        this.fetchLogInfo(requestData);
    };

    fetchRecordInfo = async (requestData: { lang: string }) => {
        const DEBUG = true;
        const TAG = 'StatsContent.fetchRecordInfo() - ';
        try {
            const response = await axios.post(StatsApi.GET_RECORD_INFO, requestData);
            DEBUG && console.log(TAG, response);
            if (response.data?.data) {
                this.childRecord.current?.updateInfo(response.data.data);
            }
        } catch (error) {
            console.error(TAG, error);
            this.handleError(error);
        }
    };

    fetchLogInfo = async (requestData: { lang: string }) => {
        const DEBUG = true;
        const TAG = 'StatsContent.fetchLogInfo() - ';
        try {
            const response = await axios.post(StatsApi.GET_LOG_INFO, requestData);
            DEBUG && console.log(TAG, response);
            if (response.data?.data) {
                this.childLog.current?.updateInfo(response.data.data);
            }
        } catch (error) {
            console.error(TAG, error);
            this.handleError(error);
        }
    };

    handleError = (error: unknown) => {
        const message = error instanceof Error ? error.message : String(error);
        this.setState({ error: message });
        this.props.handleError?.(this.props.trans('serverError'), message);
    };

    render() {
        const { trans: t } = this.props;
        const { error } = this.state;

        return (
            <main style={{ padding: 16, minHeight: '100%', background: 'var(--content-bg)' }}>
                <Space direction="vertical" size={16} style={{ width: '100%' }}>
                    <Typography.Title level={2} style={{ margin: 0 }}>
                        {t('statsMgmt')}
                    </Typography.Title>

                    {error && (
                        <Alert
                            type="error"
                            showIcon
                            closable
                            message={error}
                            onClose={() => this.setState({ error: undefined })}
                        />
                    )}

                    <Row gutter={[16, 16]}>
                        <Col xs={24} lg={12}>
                            <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                <PanelRecord trans={t} ref={this.childRecord} />
                                <PanelTest trans={t} ref={this.childTest} />
                            </Space>
                        </Col>
                        <Col xs={24} lg={12}>
                            <PanelLog trans={t} ref={this.childLog} />
                        </Col>
                    </Row>
                </Space>
            </main>
        );
    }
}
